"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeOrisalesWithPersonalMenuItems = void 0;
var _queryString = require("../constants/queryString");
const MYPAGES_NETWORK_URL = '/mypages/network';
const MEMBER_CONSULTANT_TYPE = 11;

/* Find position for merging */
const findSameNodeIndex = (currentMenu, newMenuNode) => currentMenu.findIndex(currentMenuNode => newMenuNode.title && currentMenuNode.title && newMenuNode.title.trim().toLowerCase() === currentMenuNode.title.trim().toLowerCase());
const setupSubItemsItemPaths = (itemPath, menuItems) => {
  for (const [i, subItem] of menuItems.entries()) {
    subItem.itemPath = `${itemPath}/${i}/`;
    if (subItem.subItems.length > 0) {
      setupSubItemsItemPaths(subItem.itemPath, subItem.subItems);
    }
  }
};

/* Merge new node to existings menu, recursive */
const mergeToNode = (currentMenu, newMenu, parentItemPath, rootItemUrl, consultantType, reportsItemName) => {
  for (const newMenuNode of newMenu) {
    const shouldSkipForMember = consultantType === MEMBER_CONSULTANT_TYPE && rootItemUrl === MYPAGES_NETWORK_URL && newMenuNode.title === reportsItemName;
    if (shouldSkipForMember) {
      continue;
    }
    const relatedNodeIndex = findSameNodeIndex(currentMenu, newMenuNode);
    if (relatedNodeIndex !== -1) {
      // needs to merge, subitems
      if (newMenuNode.subItems.length > 0) {
        const parentNode = currentMenu[relatedNodeIndex];
        if (parentNode !== undefined) {
          const {
            subItems,
            itemPath
          } = parentNode;
          if (subItems.length > 0) {
            mergeToNode(subItems, newMenuNode.subItems, itemPath, rootItemUrl, consultantType, reportsItemName);
          }
        }
      }
    } else if (newMenuNode.subItems.length > 0 || newMenuNode.url) {
      const itemPath = `${parentItemPath}/${currentMenu.length}/`;
      newMenuNode.itemPath = itemPath;
      if (newMenuNode.subItems.length > 0) {
        setupSubItemsItemPaths(itemPath, newMenuNode.subItems);
      }
      // needs to add, subitems
      currentMenu.push(newMenuNode);
    }
  }
};
const mergeOrisalesWithPersonalMenuItems = (personalMenuItems, orisalesMenuItems, consultantType, reportsItemName) => {
  const result = [...personalMenuItems];
  if (orisalesMenuItems.length === 0) {
    return result;
  }

  // Merge root items
  for (const newMenuNode of orisalesMenuItems) {
    const relatedRootIndex = findSameNodeIndex(result, newMenuNode);
    if (relatedRootIndex !== -1) {
      const parentNode = result[relatedRootIndex];
      if (parentNode !== undefined) {
        const parentUrl = parentNode.url;

        // modify eshop iframe links - also in all subitems
        let rootItemStr = JSON.stringify(newMenuNode);
        rootItemStr = rootItemStr.replaceAll(/"url":"(.*?)"/g, (_, url) => {
          const encodedParam = encodeURIComponent(url);
          return `"url":"${parentUrl}?${_queryString.QUERYSTRING_IFRAMEURL}=${encodedParam}"`;
        });
        const adjustedNode = JSON.parse(rootItemStr);

        // Merge both menus
        const {
          subItems,
          itemPath
        } = parentNode;
        if (relatedRootIndex !== -1 && adjustedNode.subItems.length > 0 && subItems.length > 0) {
          mergeToNode(subItems, adjustedNode.subItems, itemPath, parentUrl ?? null, consultantType, reportsItemName);
        }
      }
    }
  }
  return result;
};
exports.mergeOrisalesWithPersonalMenuItems = mergeOrisalesWithPersonalMenuItems;